import ContentLoader from "@funded-here-interface/common/src/components/ContentLoader/ContentLoader";
import { IconBrowser, IconHome, IconSignature, IconCoin } from "@tabler/icons-react";
import { FC, ReactNode, Suspense } from "react";
import { useSelector } from "react-redux";

import NavBar from "../../components/NavBar/NavBar";
import { RootState } from "../../store";
import { useStyles } from "./InvestorLayout.styles";

interface IProps {
  content: ReactNode;
}

const InvestorLayout: FC<IProps> = ({ content }) => {
  const isAuthRep = useSelector((state: RootState) => state.auth.isAuthRep); // Access isAuthRep specifically
  const { classes } = useStyles();
  const entityType = useSelector((state: RootState) => state.auth.entityType);
  const isIndividual = entityType === "individual";

  const mainMenus = [
    {
      label: "Dashboard",
      path: "/investor-dashboard/investordashboard",
      icon: <IconHome />,
    },
    {
      label: "Offer Room",
      submenu: [
        { label: "View Offer Room", path: "/note-offer-room" },
        {
          label: "Subscribed/Invested Notes",
          path: "/subscribed-invested-notes",
        },
      ],
      icon: <IconBrowser />,
    },
    ...(isAuthRep || isIndividual
      ? [
          {
            label: "Withdrawal",
            path: "/withdrawal",
            icon: <IconCoin />,
          },
        ]
      : []),
    {
      label: "Signed Documents",
      path: "/investor-signed-documents",
      icon: <IconSignature />,
    },
  ];

  return (
    <div className={classes.mainContainer}>
      <NavBar menus={mainMenus} />
      <div className={classes.hero}>
        <Suspense fallback={<ContentLoader />}>{content}</Suspense>
      </div>
    </div>
  );
};

export default InvestorLayout;
